import { useTranslation } from 'react-i18next'
import { Users, Lightbulb, Heart, Handshake, Rocket, Shield } from 'lucide-react'

const valueIcons = {
  diversity: Users,
  entrepreneurship: Lightbulb,
  loyalty: Heart,
  collaboration: Handshake,
  proactivity: Rocket,
  integrity: Shield,
}

const valueKeys = [
  'diversity',
  'entrepreneurship',
  'loyalty',
  'collaboration',
  'proactivity',
  'integrity',
] as const

export function ValuesSection() {
  const { t } = useTranslation('common')

  return (
    <section className="py-16 md:py-24 bg-[#FDF8F3] relative overflow-hidden">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 bg-pattern opacity-50" />

      <div className="container-fiorucci relative z-10">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#DF631E] text-sm font-semibold tracking-widest uppercase mb-4 block">
            Valori
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#4E2118] mb-4">
            {t('about.values.title')}
          </h2>
          <p className="text-[#4E2118]/70 text-lg">
            {t('about.values.subtitle')}
          </p>
        </div>

        {/* Values grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {valueKeys.map((key, index) => {
            const Icon = valueIcons[key]
            return (
              <div
                key={key}
                className="group relative bg-white rounded-2xl p-6 lg:p-8 shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-[#DF631E]/10 flex items-center justify-center mb-6 group-hover:bg-[#DF631E] transition-colors duration-300">
                  <Icon className="w-7 h-7 text-[#DF631E] group-hover:text-white transition-colors duration-300" />
                </div>

                {/* Content */}
                <h3 className="font-serif text-xl lg:text-2xl font-bold text-[#4E2118] mb-3">
                  {t(`about.values.items.${key}.title`)}
                </h3>
                <p className="text-[#4E2118]/70 leading-relaxed">
                  {t(`about.values.items.${key}.description`)}
                </p>

                {/* Decorative corner accent */}
                <div className="absolute top-0 right-0 w-20 h-20 overflow-hidden rounded-tr-2xl">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-[#DF631E]/5 rotate-45 transform origin-top-right group-hover:bg-[#DF631E]/10 transition-colors duration-300" />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
